module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray@3x-a218b2003ee03517bf1e83b691d88a01.png";